import React from 'react'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

interface FormElementMenuItemProps {
  className?: string
  title: string
  icon?: () => React.ReactNode
}

export const FormElementMenuItem = ({
  className,
  title,
  icon,
}: FormElementMenuItemProps) => {
  const { t } = useTranslation()
  return (
    <span className="flex items-center gap-2 text-M">
      <span
        className={twMerge(
          'flex h-9 w-9 items-center justify-center rounded-sm bg-black/5',
          className,
        )}
      >
        {icon?.()}
      </span>
      {t(title)}
    </span>
  )
}
